/*import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
      <div className="container">
        <a className="navbar-brand fw-bold" href="/">
          PMS
        </a>

        <button
          className="navbar-toggler"
          onClick={() => setOpen(!open)}
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item">
              <a className="nav-link" href="#products">
                Products
              </a>
            </li>
            <li className="nav-item ms-lg-3">
              <a className="btn btn-outline-primary" href="/admin">
                Admin Panel
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
*/
/*
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { isMobileDevice } from "../utils/device";
import { notifyInfo } from "../services/toast";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleBarcodeClick = () => {
    if (isMobileDevice()) {
      // 📱 Mobile → Barcode Scanner page
      navigate("/barcode-scanner");
    } else {
      // 💻 Desktop → Notify + Product Search page
      notifyInfo("Desktop detected: please type in the search bar.");
      navigate("/product-search");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm sticky-top">
      <div className="container-fluid px-4">
        {/ Brand /}
        <NavLink className="navbar-brand fw-bold fs-4" to="/">
          BIS  | Butter Advisory/Assisted Selling System
        </NavLink>

        {/ Mobile toggle /}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen(!open)}
        >
          <span className="navbar-toggler-icon" />
        </button>

        {/ Menu /}
        <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-3">
            <li className="nav-item">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `nav-link ${
                    isActive ? "active fw-semibold text-white" : "text-white-50"
                  }`
                }
              >
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/pages/ProductPage.tsx"
                className={({ isActive }) =>
                  `nav-link ${
                    isActive ? "active fw-semibold text-white" : "text-white-50"
                  }`
                }
              >
                Products
              </NavLink>
            </li>

            {// 🔥 BARCODE BUTTON /}
            <li className="nav-item">
              <button
                onClick={handleBarcodeClick}
                className="btn btn-warning btn-sm fw-semibold"
                type="button"
              >
                📷 Scan Barcode
              </button>

            </li>
            <li className="nav-item"> 
              <NavLink to="/pages/Pos" 
                className={({ isActive }) => 
                `nav-link ${ 
                  isActive ? "active fw-semibold text-white" : "text-white-50" 
              }` 
            } 
          > 
            POS 
          </NavLink> 
        </li>

            <li className="nav-item">
              <NavLink
                to="/reports"
                className={({ isActive }) =>
                  `nav-link ${
                    isActive ? "active fw-semibold text-white" : "text-white-50"
                  }`
                }
              >
                Reports
              </NavLink>
            </li>

            {/ Divider /}
            <li className="nav-item d-none d-lg-block">
              <span className="text-white-50">|</span>
            </li>

            {/ Admin /}
            <li className="nav-item">
              <NavLink to="/admin" className="btn btn-outline-light btn-sm">
                Admin Panel
              </NavLink>
            </li>

            {/ Auth /}
            <li className="nav-item ms-lg-2">
              <NavLink to="/login" className="btn btn-light btn-sm fw-semibold">
                Login
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
*/


import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { isMobileDevice } from "../utils/device";
import { notifyInfo } from "../services/toast";
import ComingSoonModal from "./ComingSoonModal";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [modalFeature, setModalFeature] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleBarcodeClick = () => {
    if (isMobileDevice()) {
      navigate("/barcode-scanner");
    } else {
      notifyInfo("Desktop detected: please type in the search bar.");
      navigate("/product-search");
    }
  };

  const showComingSoon = (feature: string) => {
    setModalFeature(feature);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm sticky-top">
        <div className="container-fluid px-4">
          <NavLink className="navbar-brand fw-bold fs-4" to="/">
            BIS | Butter Advisory/Assisted Selling System
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setOpen(!open)}
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
            <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-3">
              <li className="nav-item">
                <NavLink to="/" end className="nav-link">
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <button
                  className="nav-link btn btn-link text-white-50"
                  onClick={() => showComingSoon("Products")}
                >
                  Products
                </button>
              </li>

              <li className="nav-item">
                <button
                  onClick={handleBarcodeClick}
                  className="btn btn-warning btn-sm fw-semibold"
                  type="button"
                >
                  📷 Scan Barcode
                </button>
              </li>

              <li className="nav-item">
                <button
                  className="nav-link btn btn-link text-white-50"
                  onClick={() => showComingSoon("POS")}
                >
                  POS
                </button>
              </li>

              <li className="nav-item">
                <button
                  className="nav-link btn btn-link text-white-50"
                  onClick={() => showComingSoon("Reports")}
                >
                  Reports
                </button>
              </li>

              <li className="nav-item d-none d-lg-block">
                <span className="text-white-50">|</span>
              </li>

              <li className="nav-item">
                <button
                  className="btn btn-outline-light btn-sm"
                  onClick={() => showComingSoon("Admin Panel")}
                >
                  Admin Panel
                </button>
              </li>

              <li className="nav-item ms-lg-2">
                <button
                  className="btn btn-light btn-sm fw-semibold"
                  onClick={() => showComingSoon("Login")}
                >
                  Login
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {modalFeature && (
        <ComingSoonModal
          show={true}
          feature={modalFeature}
          onClose={() => setModalFeature(null)}
        />
      )}
    </>
  );
}

